import Swiper from "swiper";

import {
  Navigation,
  Pagination,
  Mousewheel,
  Autoplay,
  EffectFade,
  Parallax,
  FreeMode,
} from "swiper/modules";

try {
  const swiperEls = document.querySelectorAll(".swiper");

  const defaultSwiperConfig = {
    modules: [Navigation, Pagination, Mousewheel, Autoplay, EffectFade, Parallax, FreeMode],
    slidesPerView: "auto",
    loop: false,
    roundLengths: true,
  };

  swiperEls.forEach((swiperEl) => {
    let swiperConfig = defaultSwiperConfig;

    const swiperBtnPrevDefaultEl = swiperEl.querySelector(".swiper-button-prev");
    const swiperBtnNextDefaultEl = swiperEl.querySelector(".swiper-button-next");
    const swiperBtnPrevParentEl = swiperEl.parentNode.querySelector(".swiper-button-prev");
    const swiperBtnNextParentEl = swiperEl.parentNode.querySelector(".swiper-button-next");

    const swiperBtnPrevEl = swiperBtnPrevDefaultEl || swiperBtnPrevParentEl;
    const swiperBtnNextEl = swiperBtnNextDefaultEl || swiperBtnNextParentEl;

    const swiperPaginationDefaultEl = swiperEl.querySelector(".swiper-pagination");
    const swiperScrollbarDefaultEl = swiperEl.querySelector(".swiper-scrollbar");

    const swiperWrapperEl = swiperEl.querySelector(".swiper-wrapper");
    const swiperSlideEls = swiperEl.querySelectorAll(".swiper-slide");

    if (swiperBtnPrevEl && swiperBtnNextEl) {
      swiperConfig = {
        ...swiperConfig,
        navigation: {
          prevEl: swiperBtnPrevEl,
          nextEl: swiperBtnNextEl,
        },
      };
    }

    if (swiperPaginationDefaultEl) {
      swiperConfig = {
        ...swiperConfig,
        pagination: {
          el: swiperPaginationDefaultEl,
          clickable: true,
        },
      };
    }

    if (swiperScrollbarDefaultEl) {
      swiperConfig = {
        ...swiperConfig,
        scrollbar: {
          el: swiperScrollbarDefaultEl,
        },
      };
    }

    if (swiperEl.hasAttribute("data-swiper-config")) {
      const elementSwiperConfig = JSON.parse(swiperEl.getAttribute("data-swiper-config"));

      swiperConfig = {
        ...swiperConfig,
        ...elementSwiperConfig,
      };
    }

    const slidesCount = swiperSlideEls.length;
    const loopMinSlides = swiperConfig.loopMinSlides ?? 0;

    const addSlideDuplicates = () => {
      const fullDuplicateSets = Math.ceil(loopMinSlides / slidesCount);
      for (let i = 0; i < fullDuplicateSets; i++) {
        swiperSlideEls.forEach((slide) => {
          swiperWrapperEl.appendChild(slide.cloneNode(true));
        });
      }
    };

    if (slidesCount < loopMinSlides && slidesCount > 1) {
      let addSlideDuplicatesFlag = false;
      if (swiperConfig.loop) {
        addSlideDuplicatesFlag = true;
      }
      if (swiperConfig.breakpoints) {
        Object.keys(swiperConfig.breakpoints).forEach((bpKey) => {
          const bpData = swiperConfig.breakpoints[bpKey];
          if (window.matchMedia(`(min-width: ${bpKey}px)`)) {
            addSlideDuplicatesFlag = !!bpData.loop;
          }
        });
      }
      if (addSlideDuplicatesFlag) {
        addSlideDuplicates();
      }
    }

    new Swiper(swiperEl, swiperConfig);
  });
} catch (error) {
  console.error(error);
}
